import logo from '@/assets/logo.svg';
import { FC, lazy, Suspense, useRef } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';

import Loader from './Components/atoms/Loader';
import ErrorSection from './Components/sections/ErrorSection';
import Footer from './Components/sections/Footer';
import Header from './Components/sections/Header';

import './App.scss';

const App: FC = () => {
  const appRef = useRef<HTMLDivElement>(null);
  const SignPage = lazy(() => import('./Pages/SignPage'));
  const ThankYouPage = lazy(() => import('./Pages/ThankYouPage'));
  const router = createBrowserRouter([
    {
      path: '/',
      element: (
        <>
          <Header logo={logo} />
          <Outlet />
          <Footer />
        </>
      ),
      children: [
        {
          path: '/',
          element: (
            <Suspense fallback={<Loader variant="big" />}>
              <SignPage appRef={appRef} />
            </Suspense>
          ),
        },
        {
          path: 'thank-you',
          element: (
            <Suspense fallback={<Loader variant="big" />}>
              <ThankYouPage appRef={appRef} />
            </Suspense>
          ),
        },
        {
          path: '*', // Route di fallback per gestire tutte le altre route
          element: (
            <Suspense fallback={<Loader variant="big" />}>
              <ErrorSection status={400} message="Page not found" />
            </Suspense>
          ),
        },
      ],
    },
  ]);
  return (
    <>
      <div className="App" ref={appRef}>
        <RouterProvider router={router} />
      </div>
    </>
  );
};

export default App;
